import * as actions from './actions';


export default (state = {}, action) => {
  switch (action.type) {
    case actions.INIT.BEGIN:
      return {
        ...state,
        projectId: action.projectId,
        items: [],
      };
    case actions.INIT.END:
      return {
        ...state,
        userList: action.userList,
      };
    case actions.INVALIDATE.END:
      return {
        ...state,
        items: action.items,
      };
    case actions.SEARCH:
      return {
        ...state,
        q: action.q,
      };
    case actions.SET_INACTIVE:
      return {
        ...state,
        inactive: action.value,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/user/reducer.js